import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocalStorage, useReadLocalStorage } from "usehooks-ts";
import { setModalBalance, setTypeLogin } from "../../../store/siteSlice";
import { DEBUG, ENUM_ACCOUNT_REGISTER, ENUM_LCS_NAME, ENUM_LOGIN } from "../../../store/enums";
import { API_USER } from "../../../api/user";
import { successToast } from "../../mui/Toaster.jsx";
import { setInfo, setUserId } from "../../../store/userSlice";
import ShowContainer from "../../mui/ShowContainer";
import AuthTg from "../../mui/auth_tg/AuthTg";
import CusForm from "../../mui/CusForm";
import CusInput from "../../mui/custom_input/CusInput";
import CusButton from "../../mui/custom_button/CusButton";
import CheckboxInfo from "../../mui/checkbox_info/CheckboxInfo";
import { Link } from "react-router-dom";
import IconLock from "../../mui/JSXIcons/IconLook";
import { dispatchCusEvent } from "../../../utils/utils";
import { ENUM_COMMON_EVENT } from "../../../hooks/common/useListener";
import { ENUM_HASH } from "../../../hooks/other/useUrlParc";
import { useLocation } from "react-router-dom";
import CusCaptcha from "../../CusCaptcha";
import CusSegment from "../../mui/cus_segment/CusSegment";
import { useAppSelector } from "../../../store/index.ts";
import EmailPhone from "./email-phone/EmailPhone.jsx";
import GoogleAuth from "./googleAuth/GoogleAuth.jsx";
import "./login-fields.scss";

export default function LoginFields({
  closeModal,
  dataLogin,
  setForgotPas,
  isSwitch = true,
  myBlock,
  onSuccessLogin,
  h3Text
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const hash = location.hash;

  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";
  const pbParams = useReadLocalStorage(ENUM_LCS_NAME.pbParams) || "";
  const [, setAlreadyAccount] = useLocalStorage(ENUM_LCS_NAME.alreadyAccount);

  const typeLogin =
    useAppSelector((state) => state.site.modals?.data?.login?.type) || ENUM_LOGIN.register;
  const botName = useAppSelector((state) => state.common.botName);
  const casinoName = useAppSelector((state) => state.common.casinoName);
  const currency = useAppSelector((state) => state.user.currency);
  const captchaUsing = useAppSelector((state) => state.site.captchaUsing);
  const emailRegEnabled = useAppSelector((state) => state.common.emailRegEnabled);
  const tgRegEnabled = useAppSelector((state) => state.common.tgRegEnabled);
  const phoneRegEnabled = useAppSelector((state) => state.common.phoneRegEnabled);

  const [disableBtn, setDisableBtn] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);

  const captchaRef = useRef();

  const isLogin = typeLogin == ENUM_LOGIN.login;

  const isMailOrPhone = emailRegEnabled || phoneRegEnabled;

  const changeTypeLogin = (type) => dispatch(setTypeLogin(type));

  const getTextObjTitle = () => {
    if (phoneRegEnabled && emailRegEnabled)
      return {
        login: "Login via Email or Phone",
        register: "Registration via Email or Phone"
      };

    if (phoneRegEnabled)
      return {
        login: "Login via Phone",
        register: "Registration via Phone"
      };

    return {
      login: "Login via Email",
      register: "Registration via Email"
    };
  };

  const typeOptions = [
    { label: t("Login"), value: ENUM_LOGIN.login },
    { label: t("Registration"), value: ENUM_LOGIN.register }
  ];

  const titleByType = {
    [ENUM_LOGIN.login]: t("Login"),
    [ENUM_LOGIN.register]: t("Register")
  };

  const subTitleByType = {
    [ENUM_LOGIN.login]: t("Login to your account"),
    [ENUM_LOGIN.register]: t("Create an account in casino", { casino: casinoName })
  };

  const btnTextByType = {
    [ENUM_LOGIN.login]: t("Login"),
    [ENUM_LOGIN.register]: t("Registration")
  };

  // const tgTitleByType = {
  //   [ENUM_LOGIN.login]: t("Login via Telegram"),
  //   [ENUM_LOGIN.register]: t("Registration via Telegram")
  // };

  const emailTitleByType = {
    [ENUM_LOGIN.login]: t(getTextObjTitle().login),
    [ENUM_LOGIN.register]: t(getTextObjTitle().register)
  };

  const checkDepositOn = () => {
    if (hash.includes(ENUM_HASH.signup_deposit_on)) dispatch(setModalBalance(true));
  };

  const onComeIn = async (e, field) => {
    e.preventDefault();
    setBtnLoading(true);

    console.log("field", field);

    const info = {
      email: field.email,
      phone: field.phone.replaceAll(" ", ""),
      password: field.password,
      captcha: captchaRef.current?.getValue?.(),
      currency: currency
    };

    if (typeLogin === ENUM_LOGIN.register) {
      const domain = window.location.hostname;

      info.domain = domain;
      info.start_r = start_r;
      info.pb_params = pbParams;
    }

    const methodLogin = info.phone ? API_USER.login.phone : API_USER.login.email;

    setDisableBtn(true);
    methodLogin(info)
      .then((e) => {
        console.log(e, "ee");

        const data = e.data;
        const error = data.dataError || data.error || "error" in data;
        if (DEBUG) console.log("loginEmail res", e);

        if (error) {
          captchaRef.current?.reset();
          return;
        }

        dispatch(setUserId(data.user_id));
        successToast(t("Successfully"));

        closeModal(true);
        dataLogin?.cb?.();
        onSuccessLogin?.();

        setTimeout(() => {
          dispatchCusEvent(ENUM_COMMON_EVENT.getBalance);
        }, 100);

        dispatch(
          setInfo({
            nickname: field.email,
            email: field.email,
            register: ENUM_ACCOUNT_REGISTER.email
          })
        );
        setAlreadyAccount(true);

        if (typeLogin === ENUM_LOGIN.register) {
          dispatch(setModalBalance(true));
        }

        checkDepositOn();
      })
      .catch(console.log)
      .finally(() => {
        captchaRef.current?.reset();
        setDisableBtn(false);
        setBtnLoading(false);
      });
  };

  useEffect(() => {
    captchaRef.current?.reset();
  }, []);

  useEffect(() => {
    if (isLogin) {
      setShowCaptcha(captchaUsing.auth ?? true);
    } else {
      setShowCaptcha(captchaUsing.reg ?? true);
    }
  }, [isLogin]);

  const showTgLogin = botName && tgRegEnabled;

  return (
    <div className="login-fields">
      <h2>{titleByType[typeLogin]}</h2>
      {h3Text ? t(h3Text) : <h3 className="login-fields__title">{subTitleByType[typeLogin]}</h3>}

      <ShowContainer condition={isSwitch}>
        <CusSegment
          className="login__segment custom-segment"
          value={typeLogin}
          options={typeOptions}
          onChange={changeTypeLogin}
        />
      </ShowContainer>

      <ShowContainer condition={!isMailOrPhone && !showTgLogin}>
        <div className="auth-enabled__plug">
          <span className="auth-enabled__plug__text">
            {emailTitleByType[typeLogin]} {t("temporarily unavailable")}
          </span>
        </div>
      </ShowContainer>

      <div className="login__auth__widgets">
        {/* <ShowContainer condition={botName && tgRegEnabled}> */}
        {/* <span className="tg__title">
          <div className="tg__title__left" />
          <span className="tg__title__text">{tgTitleByType[typeLogin]}</span>
          <div className="tg__title__right" />
          </span> */}
        <ShowContainer condition={botName && tgRegEnabled}>
          <div className="login__auth login__auth-tg">
            <AuthTg
              successCb={() => {
                dataLogin?.cb?.();
                checkDepositOn();
              }}
              closeModal={closeModal}
            />
          </div>
        </ShowContainer>

        <GoogleAuth />
      </div>

      <ShowContainer condition={isMailOrPhone}>
        <CusForm onSubmit={onComeIn} className={"login__form"}>
          <span className="tg__title">
            <div className="tg__title__left" />
            <span className="tg__title__text">{emailTitleByType[typeLogin]}</span>
            <div className="tg__title__right" />
          </span>

          <EmailPhone typeLogin={typeLogin} />

          <CusInput
            name={"password"}
            placeholder={"Password"}
            type={"password"}
            autocomplete="current-password"
            required
            minLength={8}
            iconJSXstart={<IconLock />}
          />
          <ShowContainer condition={showCaptcha}>
            <CusCaptcha captchaRef={captchaRef} />
          </ShowContainer>

          <ShowContainer condition={myBlock}>{myBlock}</ShowContainer>

          <CusButton
            className="login-submit"
            text={btnTextByType[typeLogin]}
            type={"submit"}
            disable={disableBtn}
            color="gradient-blue"
            btnLoading={btnLoading}
            setBtnLoading={setBtnLoading}
          />
          <ShowContainer condition={!isLogin}>
            <CheckboxInfo
              defaultChecked
              id={"login-agree"}
              text={
                <>
                  <span>{t("I agree to the")}</span>{" "}
                  <Link target="_blank" to={"/terms"}>
                    {t("User Agreement")}
                  </Link>{" "}
                  <span>{t("and confirm that I am over 18 years old.")}</span>
                </>
              }
            />
          </ShowContainer>
        </CusForm>
      </ShowContainer>
      <ShowContainer condition={isLogin && setForgotPas && emailRegEnabled}>
        <button className="forgot-pas" onClick={() => setForgotPas(true)}>
          {t("Forgot your password?")}
        </button>
      </ShowContainer>
    </div>
  );
}
